












import Vue from 'vue';
import { IBlogEntry } from '@/common/interfaces/frontpage.interface';
import BlogEntryMobile
  from '@/components/frontpage/subcomponents/blogsection/BlogEntryMobile.vue';

export default Vue.extend({
  name: `BlogSectionMobile`,
  components: { BlogEntryMobile },
  props: {
    blogEntries: {
      required: true,
      type: Array as () => IBlogEntry[],
    },
  },
});
